import { Injectable, Injector } from '@angular/core';
import { ApiService } from "../api.service";

@Injectable()
export class ClashService {

	constructor(private apiService: ApiService) {}

	getConfigByName(configName) {
		return this.apiService.loadConfig("./assets/config/clash/" + configName + ".json");
	}

	getAllSceneList(){
		return this.getConfigByName("sceneList");
	}

	/*保存情景模拟的答题 */
	saveExercisesAnswers(exerciseId,data){
		return this.apiService.ajax({
			'type': 'post',
			'data':data,
			'url': '/sr/resolvingConflicts/saveExercisesAnswers'
		});
	}

// 保存第三阶段情景模拟答题
  saveStepThreeExercisesAnswers(exerciseId,data){
    return this.apiService.ajax({
      'type': 'post',
      'data':data,
      'url': '/sr/resolvingConflicts/saveExercisesAnswersMult'
    });
  }

	/*保存进度 */
	saveProgress(exerciseId,data){
		return this.apiService.ajax({
			'type': 'post',
			'data':data,
			'url': '/sr/resolvingConflicts/saveProgress/' + exerciseId
		});
	}
	/*重做情景模拟 */
	reset(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/resolvingConflicts/reset/' + exerciseId
		});
	}

	/* 获取当前步骤 */
	getProgress(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/resolvingConflicts/getProgress/' + exerciseId
		});
	}


	/* 获取用户情景模拟决策树  */
	getExercises(exerciseId,step){
		return this.apiService.ajax({
			'type': 'get',
        'url': '/sr/resolvingConflicts/exercises/' + exerciseId +'/'+ step
		});
	}

  /* 获取用户情景模拟决策树第三阶段 */
  getStepThreeExercises(exerciseId,step){
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/resolvingConflicts/exercisesMult/' + exerciseId +'/'+ step
    });
  }

	/* 获取用户解决冲突情景模拟决策树(历史回顾)  */
	getExercisesHis(exerciseId,step){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/resolvingConflicts/exercisesHis/' + exerciseId +'/'+ step
		});
	}



	/* 完成解决冲突情景模拟  */
	finishExercises(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/resolvingConflicts/finish/' + exerciseId
		});
	}

	/* 获取用户解决冲突能力下的情景模拟列表  */
	getPracticeList(learningPathId,practiceMetaId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/resolvingConflicts/createAndGet/' + learningPathId +'/'+ practiceMetaId
		});
	}

  /* 保存解决冲突能力下的情景模拟保存点  */
  setExerciseSavePoint(exerciseId,data){
    return this.apiService.ajax({
      'type':'post',
      'data':data,
      'url':'/sr/resolvingConflicts/saveMaxSceneReview'
    })
  }

  /* 获取解决冲突能力下的情景模拟保存点  */
  getExerciseSavePoint(exerciseId){
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/resolvingConflicts/getMaxSceneReview/' + exerciseId
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/case-practice-clash/ClashService.ts